import AppConstants from '../config/app.constants';

let HolidayService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/holiday`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getGrouped = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/holiday/grouped`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/holiday/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let createGrouped = (data) => {
        return $http
            .post(AppConstants.api + `/holiday/grouped`, data)
            .then((res) => {
                return res.data
            })
    };

    let remove = (id) => {
        return $http
            .delete(AppConstants.api + `/holiday/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let removeGrouped = ({name, branch}) => {
        return $http
            .delete(AppConstants.api + `/holiday/grouped/${branch}/${name}`)
            .then((res) => {
                return res.data
            })
    };

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/holiday/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/holiday/${id}`)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        getGrouped,
        create,
        createGrouped,
        remove,
        removeGrouped,
        update,
        get
    };
};

HolidayService.$inject = ['$http', '$q']

export default HolidayService;


// WEBPACK FOOTER //
// ./client/app/services/holidays.service.js